import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AccountsInventoryComponent } from '@brightnav/accounts';

/**
 * Accounts tab host — inventory list for the selected client.
 * Add future Accounts sections here without touching FA layout.
 */
@Component({
  selector: 'bn-accounts-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AccountsInventoryComponent],
  template: `
    <div class="bn-accounts-tab flex flex-col gap-4">
      <bn-accounts-inventory />
    </div>
  `,
})
export class AccountsTabComponent {}
